import { div } from '@mui/system'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button'
import { TextInput } from '../../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { CreateReTargetCustomerService, UpdateReTargetCustomerService, UpdateReTargetFinalCheckCustomerService } from '../../../services/admin/ReTargetCustomerServices'
import { BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'

function ReTargetCustomerCE() {
 
  const [data,setdata] = useState({target_info:'',final_check:'',final_check_completed:false,is_active:false});  
  const [error,seterror] = useState({target_info:'',final_check:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.target_info){
        seterror({...error,target_info:'Target Info field is required *'})
    }else if(!data.final_check){
        seterror({...error,final_check:'Final Check field is required *'})
    }else{
        if(state?._id === undefined || state?._id === null){
        const response = await CreateReTargetCustomerService(data)
        if (response.status === 201) {
          resetform()
          toast.success('Re Target Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,days:response?.data?.errors?.days})
        } 
      }else{
        let send_data = {...data}
        const response = await UpdateReTargetCustomerService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Re Target Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,days:response?.data?.errors?.days})
        } 
      }
  }
  }

  async function submitform1(){
    const response = await UpdateReTargetFinalCheckCustomerService(data,state?._id)
    if (response.status === 200) {
      resetform()
      navigate(-1)
      toast.success('Re Target Final Check Successfully')
    }   
    if(response.status === 422){
      seterror({...error,days:response?.data?.errors?.days})
    } 
  }


  function resetform(){
    setdata({target_info:'',final_check:'',final_check_completed:false,is_active:false})
    seterror({target_info:'',final_check:''})
  }
  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} ReTarget Customer</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> ReTarget Customer</b> for your clients segregate followup.</h6>
     

        <TextInput 
            label={'Target Info Heading'}  
            variant="standard"
            name="target_info"
            type="text"
            error={error.target_info}
            value={data.target_info}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

<div className="w-full mt-2">
          
          {/* Final Check */}
          <label className="text-[11px] block mb-1">Final Check</label>
          <input
            type="time"
            className="border p-1.5 w-full text-[11px] border-gray-300"
            value={data?.final_check || ''}
            onChange={(e) => {
              setdata({
                ...data,
                final_check:  e.target.value
              });
              seterror({ ...error, final_check: ''
             });
            }}
          />
          </div>

          <div className='flex items-center mt-2 mr-2'>
            {data?.is_active ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,is_active:!data.is_active})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,is_active:!data.is_active})}  /> }
            <h6 className="text-[10px] font-[600] ml-1">Is Active</h6> 
          </div>

          <div className='flex items-center mt-0 mr-2'>
            {data?.final_check_completed ?  <BiCheckboxSquare size={22} className='text-slate-800' />  : <BiCheckbox size={22} className='text-slate-300'  /> }
            <h6 className="text-[10px] font-[600] ml-1">Final Check Completed</h6> 
          </div>


          
        <div className='mt-5 flex items-center'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE RE TARGET" : "ADD RE TARGET"}  onClick={submitform} />  
        <h6 className='w-[5px]'></h6>
        {!state?.final_check_completed && <ButtonOutlinedAutoWidth btnName={"FINAL CHECK"}  onClick={submitform1} />}
        </div>


    </div>
    </div>
  )
}

export default ReTargetCustomerCE